<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> MANUTENÇÃO DE PREÇO - EXPRESS </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="page === 1"
          >FILTROS PARA EDIÇÃO DE PREÇOS</v-toolbar-title
        >
        <v-toolbar-title v-if="page === 2">REAJUSTE DE PREÇOS</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn
          dark
          color="blue darken-3"
          class="mr-0"
          v-if="page === 1"
          @click="updateByTable()"
        >
          <v-icon left>mdi-microsoft-excel</v-icon> Importar Tabela de Preço
        </v-btn> -->
        <v-btn
          dark
          color="green darken-3"
          class="mr-15"
          v-if="page === 2"
          @click="updatePrices()"
        >
          <v-icon left>mdi-cash-multiple</v-icon> Atualizar Preços
        </v-btn>
        <v-btn
          outlined
          color="grey darken-3"
          v-if="page === 2"
          @click="goToBackList()"
        >
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        v-if="page === 1"
      >
        <v-container fluid>
          <v-alert type="success" v-if="successSave">
            <template v-slot:close>
              <v-icon @click="() => (successSave = false)"> mdi-close </v-icon>
            </template>
            Preços Atualizados com Sucesso
          </v-alert>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Fornecedor"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :items="collections"
                item-text="name"
                item-value="id"
                v-model="collection"
                label="Coleção"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :items="categories"
                item-text="name"
                item-value="id"
                v-model="category"
                label="Categoria"
                @change="changeCategory"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :items="subcategories"
                item-text="name"
                item-value="id"
                v-model="subcategory"
                label="Subcategoria"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-text-field
                v-model="reference"
                label="Referência"
                dense
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <!-- <v-autocomplete
                v-model="material"
                :items="materials"
                :loading="isLoadingMaterial"
                :search-input.sync="searchMaterial"
                color="white"
                hide-no-data
                hide-selected
                solo
                dense
                outlined
                clearable
                item-text="Description"
                item-value="API"
                label="Material"
                placeholder="Buscar Material"
                prepend-icon="mdi-book-search-outline"
                @click:prepend="handleClickHelpMaterial"
                append-icon="mdi-palette-swatch"
                return-object
              ></v-autocomplete> -->
              <v-select
                :items="materials"
                item-text="name"
                item-value="id"
                v-model="material"
                label="Material"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <!-- <v-autocomplete
                v-model="color"
                :items="colors"
                :loading="isLoadingColor"
                :search-input.sync="searchColor"
                color="white"
                hide-no-data
                hide-selected
                solo
                dense
                outlined
                clearable
                item-text="Description"
                item-value="API"
                label="Cor"
                placeholder="Buscar Cor"
                append-icon="mdi-palette"
                prepend-icon="mdi-book-search-outline"
                @click:prepend="handleClickHelpColor"
                return-object
              ></v-autocomplete> -->
              <v-select
                :items="colors"
                item-text="name"
                item-value="id"
                v-model="color"
                label="Cor"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-select
                :items="technologies"
                item-text="name"
                item-value="id"
                v-model="technology"
                label="Tecnologia"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" md="2">
              <v-btn color="blue darken-3" dark class="" @click="validate">
                <v-icon left>mdi-magnify</v-icon> Buscar
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="text-h6">Produtos</label>
              <v-divider></v-divider>
              <v-alert border="bottom" color="pink darken-1" dark v-if="error">
                <v-row align="center">
                  <v-col class="grow">
                    {{ error }}
                  </v-col>
                  <v-col class="shrink">
                    <v-btn text icon @click="error = ''">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="green darken-3"
                outlined
                small
                @click="selectAll"
                v-if="
                  products.length > productsSelected.length ||
                  products.length == 0
                "
              >
                <v-icon left>mdi-checkbox-marked-outline</v-icon>
                Selecionar Todos
              </v-btn>
              <v-btn
                color="red darken-3"
                outlined
                small
                @click="deselectAll"
                v-if="
                  products.length === productsSelected.length &&
                  products.length > 0
                "
              >
                <v-icon left>mdi-checkbox-blank-outline</v-icon>
                Desmarcar Todos
              </v-btn>
              <v-btn
                color="blue darken-2"
                dark
                class="ml-5"
                small
                @click="goToPageTwo"
              >
                Manutenção dos Protudos Selecionados
                <v-icon right>mdi-arrow-right-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-simple-table fixed-header height="300px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">Referência</th>
                      <th class="text-left">Produto</th>
                      <th class="text-left">Fornecedor</th>
                      <th class="text-left">Categoria</th>
                      <th class="text-left">Subcategoria</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in products" :key="item.id">
                      <td>
                        <v-checkbox
                          :value="item"
                          v-model="productsSelected"
                        ></v-checkbox>
                      </td>
                      <td>{{ item.company_code }}{{ item.reference }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.company_code }} - {{ item.company }}</td>
                      <td>{{ item.category }}</td>
                      <td>{{ item.subcategory }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-container fluid v-if="page === 2">
        <v-row>
          <v-col>
            <v-progress-linear
              v-if="loadingTableEan"
              indeterminate
            ></v-progress-linear>
            <TablePriceExpanded
              :productsSelected="productsSelected"
              :handleFocusPercentCif="handleFocusPercentCif"
              :handleBlurPercentCif="handleBlurPercentCif"
              :handleChangePercentCif="handleChangePercentCif"
              :handleChangeNewPriceCif="handleChangeNewPriceCif"
              :handleBlurNewPriceCif="handleBlurNewPriceCif"
              :percentCif="percentCif"
              :handleFocusPercentMult="handleFocusPercentMult"
              :handleBlurPercentMult="handleBlurPercentMult"
              :handleChangePercentMult="handleChangePercentMult"
              :handleChangeNewPriceMult="handleChangeNewPriceMult"
              :handleBlurNewPriceMult="handleBlurNewPriceMult"
              :percentMult="percentMult"
            />
            <!-- <v-simple-table fixed-header height="550px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="100">Referência</th>
                    <th class="text-left" width="400">Produto</th>
                    <th class="text-right" width="150">R$ Rede</th>
                    <th class="text-right" width="150">R$ Multimarcas</th>
                    <th class="text-right" width="150">R$ Novo Rede</th>
                    <th class="text-right" width="150">R$ Novo Multimarcas</th>
                    <th class="text-right" width="160">% Reajuste Rede</th>
                    <th class="text-right" width="160">
                      % Reajuste Multimarcas
                    </th>
                  </tr>
                  <tr>
                    <th class="text-left"></th>
                    <th class="text-left"></th>
                    <th class="text-right"></th>
                    <th class="text-right"></th>
                    <th class="text-right"></th>
                    <th class="text-right"></th>
                    <th class="text-right">
                      <v-text-field
                        label="% Reajuste"
                        hide-details
                        outlined
                        dense
                        reverse
                        @focus="handleFocusPercentCif"
                        @blur="handleBlurPercentCif"
                        @input="handleChangePercentCif"
                        v-model.number="percentCif"
                      ></v-text-field>
                    </th>
                    <th class="text-right">
                      <v-text-field
                        label="% Reajuste"
                        hide-details
                        outlined
                        reverse
                        dense
                        @focus="handleFocusPercentMult"
                        @blur="handleBlurPercentMult"
                        @input="handleChangePercentMult"
                        v-model.number="percentMult"
                      ></v-text-field>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in productsSelected" :key="item.id">
                    <td>{{ item.company_code }}{{ item.reference }}</td>
                    <td>{{ item.name }}</td>
                    <td class="text-right">{{ item.price_cif }}</td>
                    <td class="text-right">{{ item.price_mult }}</td>
                    <td class="text-right">
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        class="text-right"
                        @input="handleChangeNewPriceCif(item)"
                        @blur="handleBlurNewPriceCif(item)"
                        v-model.number="item.new_price_cif"
                      ></v-text-field>
                    </td>
                    <td class="text-right">
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        class="text-right"
                        @input="handleChangeNewPriceMult(item)"
                        @blur="handleBlurNewPriceMult(item)"
                        v-model.number="item.new_price_mult"
                      ></v-text-field>
                    </td>
                    <td class="text-right">{{ item.percent_cif }}%</td>
                    <td class="text-right">{{ item.percent_mult }}%</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table> -->
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as ColorAPI from "@/api/requests/ColorRequest";
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as SubcategoryAPI from "@/api/requests/SubcategoryRequest";
import * as MaterialAPI from "@/api/requests/MaterialRequest";
import * as ProductTechnologyAPI from "@/api/requests/ProductTechnologyRequest";

import TablePriceExpanded from "@/components/TablePriceExpanded";
export default {
  components: { TablePriceExpanded },
  data: () => ({
    page: 1,
    loading: false,
    error: "",
    company: "",
    companies: [],
    collection: "",
    collections: [],
    category: "",
    categories: [],
    subcategory: "",
    subcategories: [],
    reference: "",
    materials: [],
    material: "",
    isLoadingMaterial: false,
    searchMaterial: "",
    colors: [],
    color: "",
    isLoadingColor: false,
    searchColor: "",
    technologies: [],
    technology: "",
    products: [],
    productsSelected: [],
    loadingTableEan: false,
    valid: true,
    lazy: false,
    successSave: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    percentCif: 0,
    percentMult: 0,
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
      this.getCollections();
      this.getCategories();
      this.getColors();
      this.getMaterials();
      this.getTechnologies();
    },
    validate() {
      if (this.$refs.form.validate()) {
        let dataSearch = {};
        dataSearch.type = "price-update";
        dataSearch.company_id = this.company == null ? "" : this.company;
        dataSearch.collection_id =
          this.collection == null ? "" : this.collection;
        dataSearch.category_id = this.category == null ? "" : this.category;
        dataSearch.subcategory_id =
          this.subcategory == null ? "" : this.subcategory;
        dataSearch.material_id = this.material == null ? "" : this.material;
        dataSearch.color_id = this.color == null ? "" : this.color;
        dataSearch.technology_id =
          this.technology == null ? "" : this.technology;
        dataSearch.reference = this.reference == null ? "" : this.reference;

        // FAZER VALIDACAO PARA BUSCA
        let data = new URLSearchParams(dataSearch);

        this.search(data);
      }
    },
    goToBackList() {
      this.page = 1;
    },
    updateByTable() {
      this.$router.push({ name: "UpdatePriceTable" });
    },
    async search(data) {
      this.loading = true;
      this.products = [];
      this.productsSelected = [];
      try {
        let res = await fetch(`${URL}product/search-filters`, {
          method: "POST",
          body: data,
        });
        let response = await res.json();
        this.products = response.products;
      } catch (error) {
        console.log(error);
        // this.error = "Houve um error ao salvar, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=for");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
        // console.log(this.companies);
      } catch (error) {
        this.companies = {};
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getCollections() {
      // this.loading = true;
      try {
        let data = await CollectionAPI.getAll();
        this.collections = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // console.log(this.collections);
      } catch (error) {
        this.collections = {};
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getCategories() {
      // this.loading = true;
      try {
        let data = await CategoryAPI.getAll();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // console.log(this.categories);
      } catch (error) {
        this.categories = {};
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getMaterials() {
      // this.loading = true;
      try {
        let data = await MaterialAPI.getAll();
        this.materials = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // console.log(this.materials);
      } catch (error) {
        this.materials = {};
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getTechnologies() {
      // this.loading = true;
      try {
        let data = await ProductTechnologyAPI.getAll();
        this.technologies = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // console.log(this.technologies);
      } catch (error) {
        this.technologies = {};
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async getColors() {
      // this.loading = true;
      try {
        let data = await ColorAPI.getAll();
        this.colors = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // console.log(this.colors);
      } catch (error) {
        this.colors = {};
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    async changeCategory() {
      // console.log(this.category);
      if (this.category === null) {
        return;
      }
      try {
        let data = await SubcategoryAPI.getAll(`?category_id=${this.category}`);
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
        // console.log(this.subcategories);
      } catch (error) {
        this.subcategories = {};
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    selectAll() {
      this.productsSelected = [...this.products];
    },
    deselectAll() {
      this.productsSelected = [];
    },
    goToPageTwo() {
      if (this.productsSelected.length === 0) {
        this.error =
          "Selecione pelo menos 1 produto para poder alterar o preço";
        return false;
      }
      this.productsSelected = this.productsSelected.map((product) => ({
        ...product,
        price_cif: parseFloat(product.price_cif).toFixed(2),
        price_mult: parseFloat(product.price_mult).toFixed(2),
        new_price_cif: parseFloat(product.price_cif).toFixed(2),
        new_price_mult: parseFloat(product.price_mult).toFixed(2),
        percent_cif: 0,
        percent_mult: 0,
      }));

      console.log(this.productsSelected);

      this.percentCif = 0;
      this.percentMult = 0;
      this.page = 2;
    },
    async updatePrices() {
      let data = this.productsSelected.map((product) => ({
        product_id: product.id,
        price_cif: product.price_cif,
        price_mult: product.price_mult,
        new_price_cif: product.new_price_cif,
        new_price_mult: product.new_price_mult,
        percent_cif: product.percent_cif,
        percent_mult: product.percent_mult,
      }));
      this.loadingTableEan = true;
      let myHeaders = new Headers({
        "Content-Type": "application/json",
      });
      try {
        let res = await fetch(`${URL}prices-express`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let response = await res.json();
        console.log(response);
        this.successSave = true;
        this.products = [];
        this.productsSelected = [];
        this.page = 1;
        this.company = "";
        this.category = "";
        this.collection = "";
        this.subcategory = "";
        this.material = "";
        this.color = "";
        this.reference = "";
        this.technology = "";
        this.percentCif = 0;
        this.percentMult = 0;
        // this.sizesEan = [];
        // this.colorAttrSelected = null;
        // this.materialAttrSelected = null;
        // this.successSaveEan = true;
      } catch (error) {
        this.error = "Houve um error ao salvar, tente novamente mais tarde";
      } finally {
        this.loadingTableEan = false;
      }
    },
    getNewPriceCif(item) {
      let price = item.price_cif;
      if (isNaN(this.percentCif) || this.percentCif <= 0) {
        return price;
      }
      price = parseFloat(price);
      return (price + price * (this.percentCif / 100)).toFixed(2);
    },
    getNewPercentCif(item) {
      let price = item.price_cif;
      if (isNaN(this.percentCif) || this.percentCif <= 0) {
        return price;
      }
      price = parseFloat(price);
      return (price + price * (this.percentCif / 100)).toFixed(2);
    },
    getNewPriceMult(item) {
      let price = item.price_cif;
      if (isNaN(this.percentMult) || this.percentMult <= 0) {
        return price;
      }
      price = parseFloat(price);
      return (price + price * (this.percentMult / 100)).toFixed(2);
    },
    handleChangeNewPriceCif(item) {
      let new_item = { ...item };
      let new_percent_cif = (
        (new_item.new_price_cif / new_item.price_cif - 1) *
        100
      ).toFixed(2);
      let index = this.productsSelected.findIndex(
        (product) => product.id === new_item.id
      );
      this.productsSelected[index].percent_cif = new_percent_cif;
    },
    handleBlurNewPriceCif(item) {
      let new_item = { ...item };
      let price = parseFloat(new_item.new_price_cif).toFixed(2);
      let index = this.productsSelected.findIndex(
        (product) => product.id === new_item.id
      );
      this.productsSelected[index].new_price_cif = price;
    },
    handleChangeNewPriceMult(item) {
      let new_item = { ...item };
      let new_percent_mult = (
        (new_item.new_price_mult / new_item.price_mult - 1) *
        100
      ).toFixed(2);
      let index = this.productsSelected.findIndex(
        (product) => product.id === new_item.id
      );
      this.productsSelected[index].percent_mult = new_percent_mult;
    },
    handleBlurNewPriceMult(item) {
      let new_item = { ...item };
      let price = parseFloat(new_item.new_price_mult).toFixed(2);
      let index = this.productsSelected.findIndex(
        (product) => product.id === new_item.id
      );
      this.productsSelected[index].new_price_mult = price;
    },
    handleClickHelpMaterial() {
      console.log("Help Material");
    },
    handleClickHelpColor() {
      console.log("Help Color");
    },
    handleFocusPercentCif() {
      if (this.percentCif === 0) {
        this.percentCif = "";
      }
    },
    handleBlurPercentCif() {
      if (this.percentCif === "") {
        this.percentCif = 0;
      }
    },
    handleChangePercentCif() {
      let percent = this.percentCif;
      if (this.percentCif === "") {
        percent = 0;
      }
      this.productsSelected = this.productsSelected.map((product) => ({
        ...product,
        new_price_cif: (
          parseFloat(product.price_cif) +
          parseFloat(product.price_cif) * (percent / 100)
        ).toFixed(2),
        percent_cif: percent,
      }));
    },
    handleChangePercentMult() {
      let percent = this.percentMult;
      if (this.percentMult === "") {
        percent = 0;
      }
      this.productsSelected = this.productsSelected.map((product) => ({
        ...product,
        new_price_mult: (
          parseFloat(product.price_mult) +
          parseFloat(product.price_mult) * (percent / 100)
        ).toFixed(2),
        percent_mult: percent,
      }));
    },
    handleFocusPercentMult() {
      if (this.percentMult === 0) {
        this.percentMult = "";
      }
    },
    handleBlurPercentMult() {
      if (this.percentMult === "") {
        this.percentMult = 0;
      }
    },
  },
};
</script>

<style scoped>
.text-right >>> input {
  text-align: right;
}
</style>
